import { Tooltip as RTooltip } from "radix-ui";
import type { ReactNode } from "react";

import styles from "./Tooltip.module.css";

export const TooltipProvider = RTooltip.Provider;

export type TooltipProps = {
  readonly children: ReactNode;
  readonly content: ReactNode;
  readonly side?: "bottom" | "left" | "right" | "top";
};

export const Tooltip = ({ children, content, side = "top" }: TooltipProps) => (
  <RTooltip.Root>
    <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
    <RTooltip.Portal>
      <RTooltip.Content className={styles.content} side={side} sideOffset={6}>
        {content}
        <RTooltip.Arrow className={styles.arrow} />
      </RTooltip.Content>
    </RTooltip.Portal>
  </RTooltip.Root>
);
